import React from 'react'
import type { ICellRendererParams } from '@ag-grid-community/core'

export const STAGE_STYLES: Record<string, { bg: string; color: string }> = {
  NEW: { bg: '#dcfce7', color: '#15803d' },
  MODIFIED: { bg: '#fffbeb', color: '#92400e' },
  DELETED: { bg: '#fee2e2', color: '#b91c1c' },
  UNCHANGED: { bg: '#f3f4f6', color: '#6b7280' },
}

const STAGE_LABELS: Record<string, string> = {
  NEW: 'New',
  MODIFIED: 'Modified',
  DELETED: 'Deleted',
  UNCHANGED: 'Unchanged',
}

export function StageBadgeRenderer(params: ICellRendererParams) {
  const status = params.value as string | undefined
  if (!status) return null
  const style = STAGE_STYLES[status] ?? { bg: '#f3f4f6', color: '#6b7280' }
  const isDraft =
    (params.data as Record<string, unknown> | undefined)?.__overrideStatus ===
    'DRAFT'
  return (
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        width: '100%',
        height: '100%',
        backgroundColor: style.bg,
        color: style.color,
        fontSize: 12,
        fontWeight: 600,
      }}
    >
      {isDraft && (
        <span
          title="Draft override pending"
          style={{
            display: 'inline-block',
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: '#3b82f6',
            flexShrink: 0,
          }}
        />
      )}
      {STAGE_LABELS[status] ?? status}
    </span>
  )
}
